// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"7674ec94","288":"aa43ac7a","427":"bbe46477","453":"f3c015a1","676":"7c7ae145","769":"f0cb18d7","812":"4993e0bd"}[chunkId] + ".chunk.js";
};